const INDEED = 'indeed';
const BOOST = 'boost';
const SPRING = 'spring';
const REACH = 'reach';
const JOVEO = 'joveo';
const TALROO = 'talroo';
const ZIPRECRUITER = 'zip_recruiter';

export { BOOST, INDEED, JOVEO, REACH, SPRING, TALROO, ZIPRECRUITER };
